<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    import("../static/css/lightStyle.css")
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue